import { render } from "./ClientShow.vue?vue&type=template&id=483bfcb1&scoped=true"
import script from "./ClientShow.vue?vue&type=script&lang=js"
export * from "./ClientShow.vue?vue&type=script&lang=js"

import "../../../src/assets/css/formTab.css?vue&type=style&index=0&lang=css"
import "./ClientShow.vue?vue&type=style&index=1&id=483bfcb1&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483bfcb1"]])

export default __exports__